var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1027,
    height: 930,
    viewBox: "0 0 1027 930",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "projectFiles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leftFile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M5 925L5 125H488.601L605 125V238V925H5Z",
    fill: "black",
    stroke: "#007ACC",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M103 200L53 250L103 300",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M143 300L193 250L143 200",
    stroke: "white",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M465 348H53V388H465V348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M465 436H53V476H465V436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 22",
    d: "M397 524H53V564H397V524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 23",
    d: "M442 612H53V652H442V612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M419 700H53V740H419V700Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "closing-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 18_2",
    d: "M103 788L53 838L103 888",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20_2",
    d: "M205 788L135 888",
    stroke: "white",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19_2",
    d: "M237 888L287 838L237 788",
    stroke: "white",
    strokeWidth: 10
  }))), /*#__PURE__*/React.createElement("path", {
    className: "shiftElement",
    d: "M478 426H66V466H478V426Z",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shiftElement",
    d: "M478 513H66V553H478V513Z",
    fill: "#007ACC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rightFile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M422 805V5H905.601L963.801 61.5L1022 118V805H422Z",
    fill: "black",
    stroke: "#007ACC",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M868 76H470V118H868V76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M869 150H470V193H869V150Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M818 225H470V507H818V225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M848 539H470V582H848V539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M972 614H470V657H972V614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M972 689H470V732H972V689Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    className: "shiftElement",
    d: "M888 65H490V107H888V65Z",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "shiftElement",
    d: "M830 212H482V494H830V212Z",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "corner",
    d: "M909 118V18L1012 118H909Z",
    fill: "#007ACC",
    stroke: "#007ACC",
    strokeWidth: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFiles);
export default __webpack_public_path__ + "static/media/projectFiles.1eb41deb.svg";
export { ForwardRef as ReactComponent };